import * as productContant from '.././contants/product';

var initialState =  {
	listProduct: []
};
 
var reducer = (state = initialState, action)=>{
	switch (action.type){
		case productContant.FETCH_PRODUCT:{
			return {
				...state,
				listProduct: []
			}
		}
		case productContant.FETCH_PRODUCT_SUCESS:{
			const { data } = action.payload;
			return {
				...state,
				listProduct: data,
			}
		}
		case productContant.FETCH_PRODUCT_FAILED:{
			return {
				...state,
				listProduct: []
			}
		}
		default: return state;
	}
	return state;
};

export default reducer;

